import { useEffect, useState } from 'react';

import { setupAnalytics, setupQualaroo } from '../analytics/product';

export function useSetupAnalytics() {
    const [setupDone, setSetupDone] = useState(false);

    useEffect(() => {
        if (!setupDone) {
            setupAnalytics(); // amplitude
            setupQualaroo(); // nps survey tool
            setSetupDone(true);
        }
    }, [setupDone]);
}
